import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-vh-100 teller-bg" }
const _hoisted_2 = {
  key: 0,
  class: "teller-loading-overlay"
}
const _hoisted_3 = { class: "navbar navbar-expand-lg shadow-sm teller-navbar" }
const _hoisted_4 = { class: "container-fluid px-4 d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "navbar-brand d-flex align-items-center text-white" }
const _hoisted_6 = { class: "p-2 rounded-3 me-3 teller-navbar-logo" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "text-white me-4 text-end pt-1" }
const _hoisted_9 = { class: "fw-semibold" }
const _hoisted_10 = { class: "fs-5 fw-bold" }
const _hoisted_11 = { class: "dropdown txt-username" }
const _hoisted_12 = {
  class: "btn btn-outline-light dropdown-toggle d-flex align-items-center txt-username border border-white px-4",
  style: {"padding-top":"6px","padding-bottom":"6px"},
  "data-bs-toggle": "dropdown"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_15 = {
  class: "dropdown-item",
  href: "#"
}
const _hoisted_16 = { class: "container-fluid px-4 py-4" }
const _hoisted_17 = { class: "row g-4" }
const _hoisted_18 = { class: "col-xl-3 col-lg-4" }
const _hoisted_19 = { class: "card teller-card mb-4 bg-white" }
const _hoisted_20 = { class: "card-body p-4" }
const _hoisted_21 = { class: "d-flex align-items-center mb-3" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "mb-1 fw-bold text-primary" }
const _hoisted_24 = { class: "text-muted-2" }
const _hoisted_25 = { class: "card teller-card mb-4 bg-white" }
const _hoisted_26 = { class: "card-header bg-transparent border-0 pb-0" }
const _hoisted_27 = { class: "fw-bold mb-0 d-flex align-items-center text-info" }
const _hoisted_28 = { class: "card-body pt-3" }
const _hoisted_29 = {
  class: "row g-2",
  style: {"margin-top":"-20px"}
}
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = { class: "card teller-card bg-white" }
const _hoisted_38 = { class: "card-header bg-transparent border-0 pb-0" }
const _hoisted_39 = { class: "fw-bold mb-0 d-flex align-items-center text-info" }
const _hoisted_40 = {
  class: "card-body pt-3",
  style: {"margin-top":"-10px"}
}
const _hoisted_41 = { class: "row g-3" }
const _hoisted_42 = { class: "col-6" }
const _hoisted_43 = { class: "text-center p-3 rounded-3 teller-stat-box bg-primary bg-opacity-10 border border-primary border-opacity-50" }
const _hoisted_44 = { class: "h4 mb-1 fw-bold text-primary" }
const _hoisted_45 = { class: "col-6" }
const _hoisted_46 = { class: "text-center p-3 rounded-3 teller-stat-box bg-success bg-opacity-10 border border-success border-opacity-50" }
const _hoisted_47 = { class: "h4 mb-1 fw-bold text-success" }
const _hoisted_48 = { class: "col-6" }
const _hoisted_49 = { class: "text-center p-3 rounded-3 teller-stat-box bg-danger bg-opacity-10 border border-danger border-opacity-50" }
const _hoisted_50 = { class: "h4 mb-1 fw-bold text-danger" }
const _hoisted_51 = { class: "col-6" }
const _hoisted_52 = { class: "text-center p-3 rounded-3 teller-stat-box bg-warning bg-opacity-10 border border-warning border-opacity-50" }
const _hoisted_53 = { class: "h5 mb-1 fw-bold text-warning" }
const _hoisted_54 = {
  class: "mt-3 p-3 rounded-3 teller-stat-box bg-light",
  style: {"border":"1px solid rgb(209 213 219)"}
}
const _hoisted_55 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_56 = { class: "fw-bold text-success" }
const _hoisted_57 = {
  class: "progress mt-2",
  style: {"height":"8px"}
}
const _hoisted_58 = { class: "col-xl-5 col-lg-8" }
const _hoisted_59 = { class: "card teller-card h-100 bg-white" }
const _hoisted_60 = { class: "card-header bg-transparent border-0 pb-0" }
const _hoisted_61 = { class: "fw-bold mb-0 d-flex align-items-center text-primary" }
const _hoisted_62 = { class: "card-body" }
const _hoisted_63 = {
  key: 0,
  class: "text-center"
}
const _hoisted_64 = { class: "mb-4" }
const _hoisted_65 = { class: "display-1 fw-bold mb-2 text-primary" }
const _hoisted_66 = { class: "h5 mb-3" }
const _hoisted_67 = { class: "row g-3 mb-4" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "p-3 rounded-3 teller-customer-box bg-info bg-opacity-10" }
const _hoisted_70 = { class: "fw-semibold" }
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = { class: "p-3 rounded-3 teller-customer-box bg-warning bg-opacity-10" }
const _hoisted_73 = { class: "fw-semibold" }
const _hoisted_74 = { class: "mb-4" }
const _hoisted_75 = { class: "p-3 rounded-3 d-inline-block teller-timer-box" }
const _hoisted_76 = { class: "d-flex gap-3 justify-content-center" }
const _hoisted_77 = {
  key: 1,
  class: "text-center py-5"
}
const _hoisted_78 = { class: "mb-4" }
const _hoisted_79 = { class: "col-xl-4" }
const _hoisted_80 = { class: "card teller-card bg-white" }
const _hoisted_81 = { class: "card-header bg-transparent border-0 pb-0" }
const _hoisted_82 = { class: "d-flex justify-content-between align-items-center w-100" }
const _hoisted_83 = { class: "fw-bold mb-0 d-flex align-items-center text-success" }
const _hoisted_84 = {
  class: "badge bg-success bg-gradient rounded-pill px-4 py-2 fs-6 text-white",
  style: {"line-height":"20px"}
}
const _hoisted_85 = { class: "card-body pt-3 overflow-auto teller-card-right" }
const _hoisted_86 = { class: "d-flex flex-column gap-3" }
const _hoisted_87 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_88 = { class: "flex-grow-1" }
const _hoisted_89 = { class: "d-flex align-items-center mb-2" }
const _hoisted_90 = { class: "fw-semibold mb-1 text-dark" }
const _hoisted_91 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_92 = { class: "small text-muted d-flex align-items-center" }
const _hoisted_93 = { class: "me-3" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "text-end" }
const _hoisted_97 = { class: "small text-muted" }
const _hoisted_98 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_99 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_100 = { class: "modal-content" }
const _hoisted_101 = {
  class: "modal-header",
  id: "modal_reason_header"
}
const _hoisted_102 = { class: "svg-icon svg-icon-1" }
const _hoisted_103 = { class: "modal-body" }
const _hoisted_104 = { class: "modal-footer" }
const _hoisted_105 = { class: "btn-group" }
const _hoisted_106 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_107 = { class: "modal-content" }
const _hoisted_108 = { class: "modal-header" }
const _hoisted_109 = { class: "svg-icon svg-icon-1" }
const _hoisted_110 = { class: "modal-body" }
const _hoisted_111 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_112 = { class: "modal-footer" }
const _hoisted_113 = { class: "btn-group" }
const _hoisted_114 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_115 = { class: "modal-content" }
const _hoisted_116 = { class: "modal-header" }
const _hoisted_117 = { class: "svg-icon svg-icon-1" }
const _hoisted_118 = { class: "modal-body" }
const _hoisted_119 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_120 = { class: "modal-footer" }
const _hoisted_121 = { class: "btn-group" }

import { ref, computed, onMounted, onUnmounted } from 'vue';
import {
  Play,
  Pause,
  Square,
  UserCheck,
  Clock,
  CheckCircle,
  XCircle,
  Users,
  LogOut,
  Building2,
  Activity,
  TrendingUp,
  AlertCircle,
  Timer,
  User,
  FastForward,
  Megaphone,
  RefreshCw
} from 'lucide-vue-next';
import store from '@/store';
import { Actions, Booth, Employee, QueueNumber } from '@/store/enums/StoreEnums';
import { ElMessage } from 'element-plus';
import moment from 'moment';
import { hideModal, showModal } from '@/core/helpers/dom';
import { useRouter } from 'vue-router';
import { subscribe, unsubscribe } from '@/websocket/stompService';
import { TOPICS } from '@/websocket/topics';
import { CookieComponent } from '@/assets/ts/components';
import { ElMessageBox } from "element-plus";

interface QueueItem {
  id: string | number;
  priority: string;
  number: string;
  service: string;
  waitTime: string;
  customerType: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Default',
  setup(__props) {

const workStatus = ref<'closed' | 'open' | 'receiving' | 'processing' | 'paused'>('closed');
const currentTicket = ref(null);
const loading = ref(false);
const currentTime = ref(new Date());
const employeeInfo = ref({});
const formattedDate = computed(() => currentTime.value.toLocaleDateString('vi-VN'));
const formattedTime = computed(() => currentTime.value.toLocaleTimeString());
const cMota = ref('');
const cancelLoading = ref(false);
const ticketId = ref('');
const ticketId2 = ref('');
const ticketList = ref([]);
const queueList = ref<QueueItem[]>([]);
const dailyStats = ref({ completed: 0, successful: 0, rejected: 0, avgTime: '0', total: 0 });
const statusConfig = computed(() => {
  switch (workStatus.value) {
    case 'open':
      return { colorClass: 'text-success', borderClass: 'border-success', label: 'Đang mở', icon: Play };
    case 'paused':
      return { colorClass: 'text-warning', borderClass: 'border-warning', label: 'Đang dừng', icon: Pause };
    case 'closed':
      return { colorClass: 'text-danger', borderClass: 'border-danger', label: 'Đang đóng', icon: Square };
    default:
      return { colorClass: 'text-primary', borderClass: 'border-primary', label: 'Đang mở', icon: Play };
  }
});
const StatusIcon = computed(() => statusConfig.value.icon);
const router = useRouter();
const reasonModalRef = ref();
const transferTicketModalRef = ref();
const transferTicketModalRef2 = ref();
const queueNumberTransferId = ref('');

const getEmployeeInfo = async () => {
  const info = await store.dispatch(Employee.selectByUserName);
  if(!info.data) return;
  employeeInfo.value = {
    name: info.data.cTenNhanVien,
    counter: info.data.cTenQuay,
    counterId: info.data.nMaQuay,
    department: "Cổng dịch vụ hành chính công số",
    avatar: "/img/cat.png",
    nMaTrangThai: info.data.nMaTrangThai
  };

  return;

  // switch (info.data.nMaTrangThai) {
  //   case 4:
  //     workStatus.value = 'paused';
  //     break;
  //   case 5:
  //     workStatus.value = 'closed';
  //     break;
  //   default:
  //     workStatus.value = 'open';
  //     break;
  // }
  // getBooothList();
}

const getBooothList = async () => {
  const data = await store.dispatch(Booth.getBoothList);
  if(data.code == 200 && data.data) {
    ticketList.value = data.data.filter(item => item.nMaQuay != employeeInfo.value.counterId);
  } 
  else {
    ticketList.value = [];
  }
}

function handleReloadQueue(msg) {
  queueList.value = JSON.parse(msg.body);
}

function getQueueList() {
  store.dispatch(QueueNumber.getQueueList, {}).then((res) => {    
    if(res.code == 200 && res.data)
      queueList.value = res.data;
    else
      queueList.value = [];
  });
}

function getDailyStatsByEmployee() {
  store.dispatch(QueueNumber.getDailyStatsByEmployee, {}).then((res) => {
    if (res.code == 200 && res.data)
      dailyStats.value = {
        completed: res.data[0].n_da_xu_ly,
        successful: res.data[0].n_hoan_thanh,
        rejected: res.data[0].n_tu_choi,
        avgTime: res.data[0].n_da_xu_ly == 0 ? '0' : Math.round(res.data[0].n_thoi_gian_xu_ly / res.data[0].n_da_xu_ly).toString(),
        total: res.data[0].n_da_xu_ly
      }
    else
      dailyStats.value = { completed: 0, successful: 0, rejected: 0, avgTime: '0', total: 0 };
    
  });
}

async function getProcessingQueue() {
  const res = await store.dispatch(QueueNumber.getProcessingQueue, {});
  if(res.code == 200 && res.data)
    currentTicket.value = res.data;
  else
    currentTicket.value = null;
  return;
}

function loadData() {
  Promise.all([getEmployeeInfo(), getProcessingQueue()]).then(() => {
    switch (employeeInfo.value.nMaTrangThai) {
    case 4:
      workStatus.value = 'paused';
      break;
    case 5:
      workStatus.value = 'closed';
      break;
    default:
      workStatus.value = currentTicket.value ? 'receiving' : 'open';
      break;
  }
  getBooothList();
  });
}

onMounted( async () => {
  loadData();
  // getEmployeeInfo();
  getQueueList();
  getDailyStatsByEmployee();
  // getProcessingQueue();
  subscribe("/topic/" + CookieComponent.get("userName") + "/queue-number", handleReloadQueue);

  const timer = setInterval(() => {
    currentTime.value = new Date();
  }, 1000);
  onUnmounted(() => clearInterval(timer));
});

onUnmounted(() => {
  unsubscribe("/topic/" + CookieComponent.get("userName") + "/queue-number", handleReloadQueue);
});

async function handleStatusChange(status: string) {
  if(status == "open" && currentTicket.value)
    workStatus.value = "receiving";
  else
    workStatus.value = status as typeof workStatus.value;
  let data = {
    nMaTrangThai: "1",
    cTenTrangThai: "Đang mở"
  }
  switch (status) {
    case 'paused':
      data = {
        nMaTrangThai: "4",
        cTenTrangThai: "Đang dừng"
      }
      break;
    case 'closed':
      data = {
        nMaTrangThai: "5",
        cTenTrangThai: "Đang đóng"
      }
      break;
    default:
      break;
  }
  if(status == "receiving") {
    loading.value = true;
    try {
      const res = await store.dispatch(QueueNumber.getQueueNumber, {});
      if(res.code == 200 && res.data) {
        currentTicket.value = res.data;
      } else {
        currentTicket.value = null;
        ElMessage({ message: res.msg, type: "error" });
      }
      loading.value = false;
    } catch (error) {
      console.log(error);
    }
  }
  else {
    await store.dispatch(Employee.updateStatus, data);
  }  
}
async function handleCompleteTicket(success: boolean) {
  if (success) {
    loading.value = true;
    const result = await store.dispatch(QueueNumber.completeProcess, currentTicket.value);
    if(result.code == 200) {
      ElMessage({ message: "Hoàn thành lượt làm việc", type: "success" });
      currentTicket.value = null;
      workStatus.value = "open";
    }
    else {
      ElMessage({ message: "Ghi nhận thất bại! Vui lòng liên hệ QTV để được hỗ trợ", type: "error" });
      currentTicket.value = null;
      workStatus.value = "open";
    }
    loading.value = false;
  }
  else {
    cMota.value = "";
  }
}

async function handleCallSpeaker() {
  try {    
    loading.value = true;
    const result = await store.dispatch(QueueNumber.callSpeaker, currentTicket.value);
    if(result.code == 200)
      ElMessage({ message: result.msg, type: "success" });      
    else
      ElMessage({ message: result.msg, type: "error" });
    loading.value = false;
  }
  catch (error) {
    console.log(error);
    loading.value = false;
  }
}

function handleCloseModal() {
  hideModal(reasonModalRef.value)
}

async function handleSave() {
    if(!cMota.value) {
      ElMessage({ message: "Vui lòng nhập lý do từ chối", type: "error" });
    }
    cancelLoading.value = true;
    currentTicket.value.cGhiChu = cMota.value;
    const result = await store.dispatch(QueueNumber.cancelProcess, currentTicket.value);
    cancelLoading.value = false;
    
    handleCloseModal();

    if(result.code == 200) {
      ElMessage({ message: "Ghi nhận thành công!", type: "success" });
      currentTicket.value = null;
      workStatus.value = "open";
    }
    else {
      ElMessage({ message: "Ghi nhận thất bại! Vui lòng liên hệ QTV để được hỗ trợ", type: "error" });
      currentTicket.value = null;
      workStatus.value = "open";
    }
}

function openTransferTicket() {
  ticketId.value = "";
  showModal(transferTicketModalRef.value);
}

function openTransferTicket2(item: any) {
  ticketId2.value = "";
  queueNumberTransferId.value = item.nMa;
  showModal(transferTicketModalRef2.value);
}

function closeTransferTicketModal() {
  hideModal(transferTicketModalRef.value);
}

function closeTransferTicketModal2() {
  hideModal(transferTicketModalRef2.value);
}

async function handleTransferTicket() {
    if(!ticketId.value) {
      ElMessage({ message: "Vui lòng chọn quầy làm việc chuyển đến", type: "error" });
      return;
    }
    cancelLoading.value = true;
    const ticketSelected = ticketList.value.find(item => item.nMaQuay == ticketId.value);
    currentTicket.value.nMaQuay = ticketId.value;
    currentTicket.value.cTenQuay = ticketSelected.cTenQuay;
    currentTicket.value.cSoQuay = ticketSelected.cSoQuay;
    const result = await store.dispatch(QueueNumber.transferTicket, currentTicket.value);
    cancelLoading.value = false;

    if(result.code == 200) {
      closeTransferTicketModal();
      ElMessage({ message: result.msg, type: "success" });
      currentTicket.value = null;
      workStatus.value = "open";
    }
    else {
      ElMessage({ message: result.msg, type: "error" });
    }
}

async function handleTransferTicket2() {
    if(!ticketId2.value) {
      ElMessage({ message: "Vui lòng chọn quầy làm việc chuyển đến", type: "error" });
      return;
    }
    cancelLoading.value = true;    
    const result = await store.dispatch(QueueNumber.transferTicket2, {nMa: queueNumberTransferId.value, nMaQuay: ticketId2.value});
    cancelLoading.value = false;

    if(result.code == 200) {
      closeTransferTicketModal2();
      ElMessage({ message: result.msg, type: "success" });
    }
    else {
      ElMessage({ message: result.msg, type: "error" });
    }
}

function handleLogout() {
  store.dispatch(Actions.LOGOUT).then(() => {
    router.push({ name: "sign-in" })
  });
}

function handleSkip(item: any) {
  ElMessageBox.confirm("Bạn có muốn bỏ qua số này không?", "Xác nhận", {
      confirmButtonText: "Xác nhận",
      cancelButtonText: "Hủy",
      type: "warning",
    }
  )
  .then(async () => {
    loading.value = true;
    const result = await store.dispatch(QueueNumber.byPassQueueNumber, item);
    if(result.code == 200)
      ElMessage({ message: result.msg, type: "success" });
    else
      ElMessage({ message: result.msg, type: "error" });
    loading.value = false;
  })
  .catch(() => {
    // console.log("Đã hủy");
  });
}


return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[11] || (_cache[11] = [
          _createElementVNode("div", { class: "teller-loading-spinner" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "slogan pb-1" }, [
      _createElementVNode("div", { class: "text-center py-2 fw-bold fs-5 text-gradient" }, "Chúc bạn một ngày làm việc hiệu quả và nhiều năng lượng!")
    ], -1)),
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Building2), { size: 32 })
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", null, [
            _createElementVNode("div", { class: "fw-bold fs-5" }, "QMS"),
            _createElementVNode("small", { class: "opacity-75" }, "Hệ thống quản lý số thứ tự thông minh")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(formattedDate.value), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(formattedTime.value), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", _hoisted_12, [
              _createElementVNode("img", {
                src: employeeInfo.value.avatar,
                class: "rounded-circle me-2",
                width: "32",
                height: "32",
                style: {"object-fit":"cover"}
              }, null, 8, _hoisted_13),
              _createElementVNode("span", null, _toDisplayString(employeeInfo.value.name), 1)
            ]),
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_15, [
                  _createVNode(_unref(User), {
                    size: 16,
                    class: "me-2"
                  }),
                  _cache[13] || (_cache[13] = _createTextVNode("Thông tin cá nhân", -1))
                ])
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("li", null, [
                _createElementVNode("hr", { class: "dropdown-divider" })
              ], -1)),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "dropdown-item text-danger cursor-pointer",
                  onClick: handleLogout
                }, [
                  _createVNode(_unref(LogOut), {
                    size: 16,
                    class: "me-2"
                  }),
                  _cache[14] || (_cache[14] = _createTextVNode("Đăng xuất", -1))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("img", {
                  src: employeeInfo.value.avatar,
                  class: "rounded-circle me-3 border border-3 border-primary shadow",
                  width: "48",
                  height: "48",
                  style: {"object-fit":"cover"}
                }, null, 8, _hoisted_22),
                _createElementVNode("div", null, [
                  _createElementVNode("h6", _hoisted_23, _toDisplayString(employeeInfo.value.name), 1),
                  _createElementVNode("small", _hoisted_24, _toDisplayString(employeeInfo.value.counter) + " • " + _toDisplayString(employeeInfo.value.department), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass('p-3 rounded-3 text-center teller-status-box ' + statusConfig.value.borderClass)
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(StatusIcon.value), {
                  size: 28,
                  class: _normalizeClass('mb-2 ' + statusConfig.value.colorClass)
                }, null, 8, ["class"])),
                _createElementVNode("div", {
                  class: _normalizeClass(["fw-bold fs-5", statusConfig.value.colorClass])
                }, _toDisplayString(statusConfig.value.label), 3),
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "small text-muted mt-1" }, "Trạng thái quầy", -1))
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("h6", _hoisted_27, [
                _createVNode(_unref(FastForward), {
                  size: 18,
                  class: "me-2"
                }),
                _cache[17] || (_cache[17] = _createTextVNode(" Điều khiển quầy ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("button", {
                    class: "btn teller-btn teller-btn-green w-100 py-3 fw-semibold teller-btn-open",
                    onClick: _cache[0] || (_cache[0] = () => handleStatusChange('open')),
                    disabled: workStatus.value === 'processing'
                  }, [
                    _createVNode(_unref(Play), {
                      size: 20,
                      class: "mb-1 d-block mx-auto"
                    }),
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "Mở quầy", -1))
                  ], 8, _hoisted_31)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("button", {
                    class: "btn teller-btn teller-btn-blue w-100 py-3 fw-semibold teller-btn-call",
                    onClick: _cache[1] || (_cache[1] = () => handleStatusChange('receiving')),
                    disabled: workStatus.value !== 'open'
                  }, [
                    _createVNode(_unref(UserCheck), {
                      size: 20,
                      class: "mb-1 d-block mx-auto"
                    }),
                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "Gọi số", -1))
                  ], 8, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("button", {
                    class: "btn teller-btn teller-btn-yellow w-100 py-3 fw-semibold teller-btn-pause",
                    onClick: _cache[2] || (_cache[2] = () => handleStatusChange('paused')),
                    disabled: workStatus.value === 'closed'
                  }, [
                    _createVNode(_unref(Pause), {
                      size: 20,
                      class: "mb-1 d-block mx-auto"
                    }),
                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "Tạm nghỉ", -1))
                  ], 8, _hoisted_35)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("button", {
                    class: "btn teller-btn teller-btn-red w-100 py-3 fw-semibold teller-btn-close",
                    onClick: _cache[3] || (_cache[3] = () => handleStatusChange('closed'))
                  }, [
                    _createVNode(_unref(Square), {
                      size: 20,
                      class: "mb-1 d-block mx-auto"
                    }),
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "Đóng quầy", -1))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("h6", _hoisted_39, [
                _createVNode(_unref(TrendingUp), {
                  size: 18,
                  class: "me-2"
                }),
                _cache[22] || (_cache[22] = _createTextVNode(" Thống kê hôm nay ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, _toDisplayString(dailyStats.value.completed), 1),
                    _cache[23] || (_cache[23] = _createElementVNode("small", { class: "text-muted-2" }, "Hoàn thành", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, _toDisplayString(dailyStats.value.successful), 1),
                    _cache[24] || (_cache[24] = _createElementVNode("small", { class: "text-muted-2" }, "Thành công", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, _toDisplayString(dailyStats.value.rejected), 1),
                    _cache[25] || (_cache[25] = _createElementVNode("small", { class: "text-muted-2" }, "Từ chối", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, _toDisplayString(dailyStats.value.avgTime), 1),
                    _cache[26] || (_cache[26] = _createElementVNode("small", { class: "text-muted-2" }, "TB xử lý (phút)", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "fw-semibold" }, "Tỷ lệ thành công", -1)),
                  _createElementVNode("span", _hoisted_56, _toDisplayString(Math.round( dailyStats.value.total == 0 ? 0 : ((dailyStats.value.successful / dailyStats.value.total) * 100))) + "% ", 1)
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", {
                    class: "progress-bar bg-success",
                    style: _normalizeStyle(`width: ${(dailyStats.value.successful / dailyStats.value.total) * 100}%`)
                  }, null, 4)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("h6", _hoisted_61, [
                _createVNode(_unref(Activity), {
                  size: 18,
                  class: "me-2"
                }),
                _cache[28] || (_cache[28] = _createTextVNode(" Số thứ tự đang xử lý ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              (currentTicket.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, _toDisplayString(currentTicket.value.cSoThuTu), 1),
                      _createElementVNode("div", _hoisted_66, _toDisplayString(currentTicket.value.cTenDichVu), 1)
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, [
                          _createVNode(_unref(User), {
                            size: 20,
                            class: "text-info mb-2"
                          }),
                          _createElementVNode("div", _hoisted_70, _toDisplayString(currentTicket.value.cHoTenKhachHang), 1),
                          _cache[29] || (_cache[29] = _createElementVNode("small", { class: "text-muted" }, "Khách hàng", -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                          _createVNode(_unref(Clock), {
                            size: 20,
                            class: "text-warning mb-2"
                          }),
                          _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(moment)(currentTicket.value.dThoiGianBatDau).format("HH:mm:ss")), 1),
                          _cache[30] || (_cache[30] = _createElementVNode("small", { class: "text-muted" }, "Bắt đầu lúc", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_unref(Timer), {
                          size: 24,
                          class: "text-primary me-2"
                        }),
                        _cache[31] || (_cache[31] = _createElementVNode("span", { class: "fw-bold text-primary" }, "Thời gian ước tính: 10 phút", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("button", {
                        class: "btn btn-warning btn-lg px-4 py-3 fw-semibold teller-btn-action",
                        onClick: _cache[4] || (_cache[4] = () => handleCallSpeaker()),
                        style: {"border-radius":"8px"}
                      }, [
                        _createVNode(_unref(Megaphone), {
                          size: 20,
                          class: "me-2"
                        }),
                        _cache[32] || (_cache[32] = _createTextVNode(" Gọi lại ", -1))
                      ]),
                      _createElementVNode("button", {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_transfer_ticket",
                        class: "btn btn-info btn-lg px-4 py-3 fw-semibold teller-btn-action",
                        onClick: _cache[5] || (_cache[5] = () => openTransferTicket()),
                        style: {"border-radius":"8px"}
                      }, [
                        _createVNode(_unref(RefreshCw), {
                          size: 20,
                          class: "me-2"
                        }),
                        _cache[33] || (_cache[33] = _createTextVNode(" Chuyển quầy ", -1))
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-success btn-lg px-4 py-3 fw-semibold teller-btn-action",
                        onClick: _cache[6] || (_cache[6] = () => handleCompleteTicket(true)),
                        style: {"border-radius":"8px"}
                      }, [
                        _createVNode(_unref(CheckCircle), {
                          size: 20,
                          class: "me-2"
                        }),
                        _cache[34] || (_cache[34] = _createTextVNode(" Hoàn thành ", -1))
                      ]),
                      _createElementVNode("button", {
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#modal_reason",
                        class: "btn btn-danger btn-lg px-4 py-3 fw-semibold teller-btn-action",
                        onClick: _cache[7] || (_cache[7] = () => handleCompleteTicket(false)),
                        style: {"border-radius":"8px"}
                      }, [
                        _createVNode(_unref(XCircle), {
                          size: 20,
                          class: "me-2"
                        }),
                        _cache[35] || (_cache[35] = _createTextVNode(" Từ chối ", -1))
                      ])
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("div", { class: "mt-4 fst-italic" }, "Hãy phục vụ khách hàng tận tâm!", -1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(_unref(Clock), {
                        size: 64,
                        class: "text-muted opacity-50"
                      })
                    ]),
                    _cache[37] || (_cache[37] = _createElementVNode("h5", { class: "text-muted mb-2" }, "Chưa có khách hàng", -1)),
                    _cache[38] || (_cache[38] = _createElementVNode("p", { class: "text-muted" }, "Nhấn \"Gọi số\" để bắt đầu phục vụ khách hàng tiếp theo", -1))
                  ]))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_79, [
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("div", _hoisted_82, [
                _createElementVNode("h6", _hoisted_83, [
                  _createVNode(_unref(Users), {
                    size: 18,
                    class: "me-2"
                  }),
                  _cache[39] || (_cache[39] = _createTextVNode(" Danh sách chờ ", -1))
                ]),
                _createElementVNode("span", _hoisted_84, _toDisplayString(queueList.value.length), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(queueList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.nMa,
                    class: _normalizeClass(["p-3 rounded-4 border-start border-5 teller-queue-box position-relative teller-queue-gradient mb-2 border-primary", {
                      'border-danger': item.priority === 'high',
                      'border-primary': item.priority === 'normal'
                    }])
                  }, [
                    _createElementVNode("div", _hoisted_87, [
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["fw-bold fs-4 me-2", {
                              'text-danger': item.priority === 'high',
                              'text-primary': item.priority === 'normal'
                            }])
                          }, _toDisplayString(item.cSoThuTu), 3),
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge teller-badge bg-opacity-10", {
                              'bg-danger text-danger': item.priority === 'high',
                              'bg-primary text-primary': item.priority === 'normal'
                            }])
                          }, _toDisplayString(item.priority === 'urgent' ? 'Từ chối' : item.priority === 'high' ? 'Ưu tiên' : 'Bình thường'), 3)
                        ]),
                        _createElementVNode("div", _hoisted_90, _toDisplayString(item.cTenDichVu), 1),
                        _createElementVNode("div", _hoisted_91, [
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("span", _hoisted_93, [
                              _createVNode(_unref(Clock), {
                                size: 14,
                                class: "me-1 text-primary"
                              }),
                              _createTextVNode(" " + _toDisplayString(_unref(moment)(item.dNgayTao).format('HH:mm')), 1)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-sm btn-icon w-auto h-auto text-primary",
                              onClick: ($event: any) => (handleSkip(item))
                            }, "Bỏ qua", 8, _hoisted_94),
                            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "mx-2 fw-bold" }, "|", -1)),
                            _createElementVNode("button", {
                              type: "button",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modal_transfer_ticket_2",
                              class: "btn btn-sm btn-icon w-auto h-auto text-primary",
                              onClick: ($event: any) => (openTransferTicket2(item))
                            }, "Chuyển quầy", 8, _hoisted_95)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", _hoisted_97, "#" + _toDisplayString(index + 1), 1)
                      ])
                    ])
                  ], 2))
                }), 128)),
                (queueList.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                      _createVNode(_unref(AlertCircle), {
                        size: 48,
                        class: "text-muted opacity-50 mb-3"
                      }),
                      _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-muted" }, "Không có khách hàng đang chờ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: "modal_reason",
      ref_key: "reasonModalRef",
      ref: reasonModalRef,
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_99, [
        _createElementVNode("div", _hoisted_100, [
          _createElementVNode("div", _hoisted_101, [
            _cache[42] || (_cache[42] = _createElementVNode("h2", { class: "fw-bolder" }, "Lý do từ chối", -1)),
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: handleCloseModal
            }, [
              _createElementVNode("span", _hoisted_102, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _cache[43] || (_cache[43] = _createElementVNode("label", { class: "fs-5 mb-2" }, "Lý do từ chối:", -1)),
            _createVNode(_component_el_input, {
              type: "textarea",
              rows: 4,
              modelValue: cMota.value,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((cMota).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createElementVNode("div", _hoisted_105, [
              _createVNode(_component_el_button, {
                plain: "",
                type: "primary",
                loading: cancelLoading.value,
                onClick: handleSave
              }, {
                default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                  _createTextVNode("Lưu", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                plain: "",
                type: "danger",
                onClick: handleCloseModal
              }, {
                default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                  _createTextVNode("Thoát", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      class: "modal fade",
      id: "modal_transfer_ticket",
      ref_key: "transferTicketModalRef",
      ref: transferTicketModalRef,
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _cache[46] || (_cache[46] = _createElementVNode("h2", { class: "fw-bolder" }, "Chuyển quầy làm việc", -1)),
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: closeTransferTicketModal
            }, [
              _createElementVNode("span", _hoisted_109, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_110, [
            _cache[47] || (_cache[47] = _createElementVNode("label", { class: "fs-5 mb-2" }, "Chọn quầy làm việc chuyển đến:", -1)),
            _createElementVNode("div", _hoisted_111, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_radio, {
                  border: "",
                  modelValue: ticketId.value,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ticketId).value = $event)),
                  key: item.nMaQuay,
                  value: item.nMaQuay
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.cTenQuay), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "value"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              _createVNode(_component_el_button, {
                plain: "",
                type: "primary",
                loading: cancelLoading.value,
                onClick: handleTransferTicket
              }, {
                default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                  _createTextVNode("Chuyển quầy", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                plain: "",
                type: "danger",
                onClick: closeTransferTicketModal
              }, {
                default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                  _createTextVNode("Thoát", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      class: "modal fade",
      id: "modal_transfer_ticket_2",
      ref_key: "transferTicketModalRef2",
      ref: transferTicketModalRef2,
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_114, [
        _createElementVNode("div", _hoisted_115, [
          _createElementVNode("div", _hoisted_116, [
            _cache[50] || (_cache[50] = _createElementVNode("h2", { class: "fw-bolder" }, "Chuyển quầy làm việc", -1)),
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: closeTransferTicketModal
            }, [
              _createElementVNode("span", _hoisted_117, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_118, [
            _cache[51] || (_cache[51] = _createElementVNode("label", { class: "fs-5 mb-2" }, "Chọn quầy làm việc chuyển đến:", -1)),
            _createElementVNode("div", _hoisted_119, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketList.value, (item) => {
                return (_openBlock(), _createBlock(_component_el_radio, {
                  border: "",
                  modelValue: ticketId2.value,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ticketId2).value = $event)),
                  key: item.nMaQuay,
                  value: item.nMaQuay
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.cTenQuay), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "value"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_120, [
            _createElementVNode("div", _hoisted_121, [
              _createVNode(_component_el_button, {
                plain: "",
                type: "primary",
                loading: cancelLoading.value,
                onClick: handleTransferTicket2
              }, {
                default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                  _createTextVNode("Chuyển quầy", -1)
                ]))]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                plain: "",
                type: "danger",
                onClick: closeTransferTicketModal2
              }, {
                default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                  _createTextVNode("Thoát", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})